import React, { useState, useEffect } from "react";
import { initializeApp } from "firebase/app";
import {
  getAuth,
  onAuthStateChanged,
  signInWithRedirect,
  signOut,
  GoogleAuthProvider,
} from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBrs_cuJpyStf6zdXaXhnhcRoM-_4TC-S4",
  authDomain: "portfolio-gonza.firebaseapp.com",
  projectId: "portfolio-gonza",
  storageBucket: "portfolio-gonza.appspot.com",
  messagingSenderId: "839023437455",
  appId: "1:839023437455:web:4029d131d37a5a73eb32fa",
  measurementId: "G-LXQW22SG5N",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

const FirebaseAuthenticator = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true); // To handle the loading state

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsLoading(false);
      if (user) {
        setUser(user);
      } else {
        setUser(null);
      }
    });

    return () => unsubscribe();
  }, []);

  const signIn = () => {
    signInWithRedirect(auth, provider);
  };

  const signOutUser = () => {
    signOut(auth)
      .then(() => {
        setUser(null);
      })
      .catch((error) => {
        // An error happened.
        console.error("Sign out error", error);
      });
  };

  if (isLoading) {
    return <div className="observer_spinner obs-center" id="fb-auth"></div>;
  }

  if (!user) {
    return (
      <div className="fb-login">
        <h1>Please sign in</h1>
        <button onClick={signIn}>
          <ion-icon name="logo-google"></ion-icon> Sign in with Google
        </button>
      </div>
    );
  }

  return <>{children}</>; // Render children when the user is authenticated
};

export default FirebaseAuthenticator;
